import { render, staticRenderFns } from "./UserFiltersRename.vue?vue&type=template&id=bfc13442"
import script from "./UserFiltersRename.vue?vue&type=script&lang=js"
export * from "./UserFiltersRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports